import LOCATIONS from './locations';

const TYPES = [
	{ label: 'Pis' },
	{ label: 'Xalet / Casa individual' },
	{ label: 'Estudi' },
];

export { TYPES, LOCATIONS };
